export default __webpack_public_path__ + "static/media/logo.884a4ba1.png";